import type { InternalAxiosRequestConfig, AxiosInstance } from 'axios'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import type { CustomAxiosResponse } from '@/types'
import { clearToken } from "@/utils";

const instance: AxiosInstance = axios.create({
  baseURL: '/api',
  timeout: 1000 * 60 * 5
})

// 请求拦截器
instance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (res: CustomAxiosResponse) => {
    const path = window.location.pathname

    if (path === '/login') {
      return res.data
    }


    if (!res.data.code || res.data.code === '1000') {
      return res.data
    } else if (res.data.code === '1004') {
      clearToken()
      ElMessage.error('请重新登录')
      window.location.pathname = '/login'
    } else {
      ElMessage.error(res.data.msg)
    }
  },
  (error) => {
    // 处理响应错误
    if (error.response) {
      switch (error.response.status) {
        case 400:
          console.error('请求错误')
          break
        case 401:
          console.error('未授权，请登录')
          break
        case 403:
          console.error('拒绝访问')
          break
        case 404:
          console.error('请求地址出错')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error(`连接错误 ${error.response.status}`)
      }
    } else {
      console.error('连接到服务器失败')
    }
    return Promise.reject(error)
  }
)

export default instance
